// authSession.ts
import { InteractionRequiredAuthError } from "@azure/msal-browser"

import { msalInstance } from "@/main"

import { getLastRoute } from "./auth/lastRoute"

let onSessionExpired: ((returnTo: string) => void) | null = null

export function registerSessionExpiredHandler(cb: (returnTo: string) => void): () => void {
  onSessionExpired = cb

  // Return a cleanup function so callers (e.g. useEffect) can unsubscribe
  return () => {
    if (onSessionExpired === cb) {
      onSessionExpired = null
    }
  }
}

export function handleSessionExpired() {
  // "Soft" session expiry – app-level only
  msalInstance.setActiveAccount(null)

  const returnTo = getLastRoute()

  if (onSessionExpired) {
    onSessionExpired(returnTo)
  }
}

// Helper used by getToken.ts
const API_SCOPES = ["api://3a90408c-832c-4f33-bbd2-4c8ff48bc7bc/API.Access"]

export async function getAccessToken() {
  const account = msalInstance.getActiveAccount()

  if (!account) {
    handleSessionExpired()
    throw new Error("No active account")
  }

  try {
    const result = await msalInstance.acquireTokenSilent({
      scopes: API_SCOPES,
      account,
    })

    return result.accessToken
  } catch (err: unknown) {
    if (err instanceof InteractionRequiredAuthError) {
      // Can't silently renew → treat as expired
      handleSessionExpired()
    }
    throw err
  }
}
